export const issueTypes = [
  { label: 'Parked in a cycle lane', value: 'CycleLane' },
  { label: 'Parked in a disabled bay', value: 'DisabledBay' },
  { label: 'Parked in a loading bay', value: 'LoadingBay' },
  { label: 'Parked in a resident bay', value: 'ResidentBay' },
  { label: 'Parked in a taxi rank', value: 'TaxiRank' },
  { label: 'Parked in an electric vehicle bay', value: 'ElectricVehicleBay' },
  {
    label: 'Parked more than 50 cm away from the edge of the kerb',
    value: 'ParkedAwayFromKerb',
  },
  { label: 'Parked on a pavement or footway', value: 'Pavement' },
  {
    label: 'Parked on a zebra crossing or crossing marked with zigzags',
    value: 'Crossing',
  },
  { label: 'Parked on single or double yellow lines', value: 'YellowLines' },
  { label: 'Other', value: 'Other' },
];
